import React, { useState, useEffect } from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
    makeStyles,
    Container,
    Paper,
    Grid,
    Typography,
    Button,
    List,
    ListItem,
    ListItemText,
} from "@material-ui/core";
import { Creators as ManufacturerActions } from "../../../store/ducks/manufacturer";

import Layout from "../../Layout/Layout";
import providerPageStyle from "./providerPageStyle";
import CustomModal from "../../CustomModal/CustomModal";
import ProviderRegister from "../../ProviderRegister/ProviderRegister";

const useStyles = makeStyles((theme) => providerPageStyle(theme));

const ProviderPage = ({ manufacturer, getManufacturer }) => {
    const [showModal, setShowModal] = useState(false)
    const [manufacturerState, setManufacturerState] = useState({})

    const { data, type } = manufacturer;

    useEffect(() => {
        if (!data) {
            getManufacturer();
        }
    }, [getManufacturer, data])

    useEffect(() => {
        if (type === "manufacturer/SEARCH") {
            setManufacturerState(data)
        }
    }, [data, type, setManufacturerState]);

    const classes = useStyles();

    const handleClosingModal = () => {
        setShowModal(false)
    }

    const handleShowModal = () => {
        setShowModal(true)
    }

    return manufacturerState?.codigo ? (
        <>
            <div className={classes.root}>
                <Layout title="Fornecedor">
                    <CustomModal open={showModal} onClose={handleClosingModal}>{(
                        <ProviderRegister manufacturerDataToEdit={manufacturerState} onFinished={handleClosingModal} />
                    )}</CustomModal>

                    <main className={classes.content}>
                        <div className={classes.appBarSpacer} />
                        <Container maxWidth="lg" className={classes.container}>
                            <Paper className={classes.containerProducts}>
                                <Grid
                                    container
                                    direction="row"
                                    justify="space-between"
                                    alignItems="center"
                                >
                                    <Typography
                                        component="h1"
                                        variant="h6"
                                        color="inherit"
                                        noWrap
                                        className={classes.title}
                                    >
                                        Informações do Fornecedor
                                    </Typography>

                                    <Button
                                        variant="contained"
                                        className={classes.registerButton}
                                        onClick={() => handleShowModal()}
                                    >
                                        Editar
                                    </Button>
                                </Grid>

                                <List>
                                    <ListItem>
                                        <ListItemText
                                            disableTypography
                                            className={classes.textWrap}
                                            primary={<Typography  className={classes.textPrimary}>Nome: </Typography>}
                                            secondary={<Typography  className={classes.textSecondary}> {manufacturerState.nome}</Typography>}
                                        />
                                    </ListItem>

                                    <ListItem>
                                        <ListItemText
                                            disableTypography
                                            className={classes.textWrap}
                                            primary={<Typography  className={classes.textPrimary}>Código: </Typography>}
                                            secondary={<Typography  className={classes.textSecondary}> {manufacturerState.codigo}</Typography>}
                                        />
                                    </ListItem>

                                    <ListItem>
                                        <ListItemText
                                            disableTypography
                                            className={classes.textWrap}
                                            primary={<Typography  className={classes.textPrimary}>Contato: </Typography>}
                                            secondary={<Typography  className={classes.textSecondary}> {manufacturerState.contato}</Typography>}
                                        />
                                    </ListItem>

                                    <ListItem>
                                        <ListItemText
                                            disableTypography
                                            className={classes.textWrap}
                                            primary={<Typography  className={classes.textPrimary}>Email: </Typography>}
                                            secondary={<Typography  className={classes.textSecondary}> {manufacturerState.email}</Typography>}
                                        />
                                    </ListItem>

                                    <ListItem>
                                        <ListItemText
                                            disableTypography
                                            className={classes.textWrap}
                                            primary={<Typography  className={classes.textPrimary}>Endereço: </Typography>}
                                            secondary={<Typography  className={classes.textSecondary}> {manufacturerState.endereco}</Typography>}
                                        />
                                    </ListItem>
                                </List>
                            </Paper>
                        </Container>
                    </main>
                </Layout>
            </div>
        </>
    ) : (
        <div className={classes.root}>
            <Layout title="Fornecedor">
                <CustomModal open={showModal} onClose={handleClosingModal}>{(
                    <ProviderRegister manufacturerDataToEdit={manufacturerState} onFinished={handleClosingModal} />
                )}</CustomModal>

                <main className={classes.content}>
                    <div className={classes.appBarSpacer} />
                    <Container maxWidth="lg" className={classes.container}>
                        <Paper className={classes.containerProducts}>
                            <Grid
                                container
                                direction="row"
                                justify="space-between"
                                alignItems="center"
                            >
                                <Typography
                                    component="h1"
                                    variant="h6"
                                    color="inherit"
                                    noWrap
                                    className={classes.title}
                                >
                                    Informações do Fornecedor
                                </Typography>

                                <Button
                                    variant="contained"
                                    className={classes.registerButton}
                                    onClick={() => handleShowModal()}
                                >
                                    Cadastrar
                                </Button>
                            </Grid>

                            <Grid
                                container
                                direction="row"
                                alignItems="center"
                            >
                                <Typography
                                    component="h1"
                                    variant="body1"
                                    color="inherit"
                                    noWrap
                                    className={classes.information}
                                >
                                    Nenhum fornecedor cadastrado no momento. clique no botão ao lado
                                    para cadastrar.
                                </Typography>
                            </Grid>
                        </Paper>
                    </Container>
                </main>
            </Layout>
        </div>
    )
}

const mapStatetoProps = (state) => ({ ...state });
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ManufacturerActions, dispatch);
};

export default connect(mapStatetoProps, mapDispatchToProps)(ProviderPage);
